import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginRequestData, SecurityResultStatus } from 'src/app/clients/system-api/SystemApiClient';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild('loginNgForm')

  loginNgForm!: NgForm;
  loginForm!: FormGroup;
  hide = true;
  submitted = false
  TransLang: string[] = [];

  loginRequestData: LoginRequestData = new LoginRequestData();

  constructor(
    private _formBuilder: FormBuilder,
    private _userService: UserService,
    private translate: TranslateService,
    private router: Router,
    private _snackBarService: SnackBarService,
    private route: ActivatedRoute,
    private sessionStorageService: SessionStorageService,
  ) {
    translate.setDefaultLang('mk');
    translate.addLangs(['mk', 'al']);
  }

  ngOnInit(): void {
    this.loginForm = this._formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });

    this.getTransLanguage();
  }

  get f() {
    return this.loginForm.controls
  }

  getTransLanguage() {
    this.TransLang = [...this.translate.getLangs()];
  }

  login() {

    this.submitted = true;
    if (this.loginForm.valid) {
      return;
    }

    this._userService.login(this.loginRequestData).subscribe(next => {
      if (next.status == SecurityResultStatus.Success) {
        this.sessionStorageService.setProfile(next.content!);
        this._snackBarService.callSnackBar(next, "Login");
        this.router.navigate(["/dashboard/home"]);

      } else {
        this._snackBarService.callSnackBar(next, "Login");
      }
    }, error => {
      this._snackBarService.callSnackBar(error);
    });
  }
}
